import { Outlet } from 'react-router';

import FloatingWhatsappButton from './components/FloatingWhatsappButton.tsx';
import Footer from './components/Footer.tsx';
import Header from './components/Header.tsx';
import { LanguageProvider } from './i18n/context.tsx';
import { useLanguage } from './i18n/hooks.ts';

function LayoutContent() {
  const { direction, language } = useLanguage();

  return (
    <main dir={direction} lang={language} className="scroll-smooth">
      <Header />
      <Outlet />
      <Footer />
      <FloatingWhatsappButton />
    </main>
  );
}

export default function Layout() {
  return (
    <LanguageProvider>
      <LayoutContent />
    </LanguageProvider>
  );
}
